import * as React from 'react';
import { Form, Formik } from 'formik';
import { SchoolEvent } from 'Src/models/event';
import { REPORT_TYPE_SERVER_TO_CLIENT_MAPPING } from 'Src/consts/report';
import { ReportActions, ReportDescription, ReportSection, ReportToggle, ReportToggleList } from '../ReportFormUi';
import '../../SchoolEventView.scss';

interface Props {
  event: SchoolEvent;
  activeSchoolId: string;
  onCloseClick: () => void;
  onSubmit: (data: any, reportType: string) => void;
}

//report 043
export function EventScoreCardReportForm({ onCloseClick, onSubmit, event, activeSchoolId }: Props) {
  const requestInitial = {
    isPrintPOM: true
  };

  return (
    <Formik
      onSubmit={values => onSubmit(values, REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.EVENT_SCORE_CARD)}
      initialValues={requestInitial}
    >
      {({ values, setFieldValue }) => (
        <Form className="eReportForm">
          <ReportDescription>
            Print a score card containing key event details such as start time, venue and team names.
          </ReportDescription>

          <ReportSection
            number={1}
            title="Include in the score card"
            hint="Choose which writable sections should appear in the generated document."
          >
            <ReportToggleList>
              <ReportToggle
                name="isPrintPOM"
                label="Keep space for Player of the Match"
                hint="Adds a field for writing the Player of the Match after the event."
                value={values.isPrintPOM}
                onChange={value => setFieldValue('isPrintPOM', value)}
              />
            </ReportToggleList>
          </ReportSection>

          <ReportActions onCancel={onCloseClick} />
        </Form>
      )}
    </Formik>
  );
}
